import { Link } from "react-router-dom";

const stats = [
  { value: "3000+", label: "影片剧集收录" },
  { value: "16", label: "覆盖影视类型" },
  { value: "每日", label: "更新热门内容" },
  { value: "多端", label: "电脑手机自适应" },
];

const features = [
  {
    icon: "ri-search-eye-line",
    title: "精准检索",
    desc: "支持按片名、演员、类型关键词模糊搜索，几秒锁定想看的影片。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选",
    desc: "类型、地区、年份三重筛选搭配排序，快速缩小范围找到好片。",
  },
  {
    icon: "ri-heart-3-line",
    title: "收藏片单",
    desc: "一键收藏喜欢的影片，记录保存在本机，下次打开就能继续看。",
  },
  {
    icon: "ri-smartphone-line",
    title: "全端适配",
    desc: "电脑、平板、手机均可流畅浏览，随时随地发现精彩影视。",
  },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100/80 px-3 py-1 text-xs font-semibold text-accent-900">
              <i className="ri-film-line"></i>
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              专注为影视爱好者打造的
              <br className="hidden sm:block" />
              内容展示与检索门户
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              「免费观看大片在线观看」汇集最新热门电影与优质电视剧资源信息，覆盖动作、科幻、悬疑、爱情、古装等多种类型。我们持续整理影片介绍、主创阵容与相关推荐，帮助你在海量内容中高效筛选、轻松浏览。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              站内影视播放为前端功能演示，不接入真实流媒体、不提供下载或会员服务，所有资源信息仅用于展示与学习参考。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200/60 bg-background-50 p-5"
              >
                <p className="font-heading text-2xl font-bold text-primary-500 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1.5 text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-lg border border-background-200/60 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100/70 text-primary-600">
                <i className={`${feature.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}